import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TrendUp, Receipt, Archive, ChartPie, UsersThree, LockKey } from "@phosphor-icons/react";
import RevenueTab from "@/components/accounting/RevenueTab";
import ExpensesTab from "@/components/accounting/ExpensesTab";
import InventoryTab from "@/components/accounting/InventoryTab";
import ReportsTab from "@/components/accounting/ReportsTab";
import AccessTab from "@/components/accounting/AccessTab";

const TABS = [
  { id: "revenue", label: "Revenue", icon: TrendUp, component: RevenueTab },
  { id: "expenses", label: "Expenses", icon: Receipt, component: ExpensesTab },
  { id: "inventory", label: "Inventory", icon: Archive, component: InventoryTab },
  { id: "reports", label: "Reports", icon: ChartPie, component: ReportsTab },
  { id: "access", label: "Access Control", icon: UsersThree, component: AccessTab, adminOnly: true },
];

export default function Accounting() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const grants = user?.accounting_access || [];
  const visible = TABS.filter((t) => isAdmin || (!t.adminOnly && grants.includes(t.id)));

  if (!visible.length)
    return (
      <div className="flex h-96 flex-col items-center justify-center gap-3 border border-border bg-card" data-testid="accounting-no-access">
        <LockKey size={40} className="text-muted-foreground" />
        <h1 className="font-heading text-2xl font-bold">No access granted</h1>
        <p className="max-w-sm text-center text-sm text-muted-foreground">
          You haven't been granted access to any accounting section. Ask the super admin to enable access for your account.
        </p>
      </div>
    );

  return (
    <div className="space-y-6" data-testid="accounting-page">
      <div>
        <h1 className="font-heading text-3xl font-bold">Smart Accounting</h1>
        <p className="text-sm text-muted-foreground">Revenue, expenses, store-room inventory and financial reports.</p>
      </div>
      <Tabs defaultValue={visible[0].id}>
        <TabsList data-testid="accounting-tabs">
          {visible.map(({ id, label, icon: Icon }) => (
            <TabsTrigger key={id} value={id} data-testid={`accounting-tab-${id}`}>
              <Icon size={15} className="mr-1.5" /> {label}
            </TabsTrigger>
          ))}
        </TabsList>
        {visible.map(({ id, component: Component }) => (
          <TabsContent key={id} value={id} className="mt-4">
            <Component />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
